package com.routexk.quiz.core.config

import kotlinx.browser.window

object AppConfig {
    private val isDevelopment = window.location.hostname == "localhost" ||
                                window.location.hostname == "127.0.0.1"

    val environment: Environment = if (isDevelopment) {
        Environment.DEVELOPMENT
    } else {
        Environment.PRODUCTION
    }

    private val cachedApiUrl: String by lazy {
        when (environment) {
            Environment.DEVELOPMENT -> getEnv("API_URL") ?: "http://localhost:8080/api"
            Environment.PRODUCTION -> getEnv("API_URL") ?: "https://api.routemap.ai/api"
        }
    }

    val apiUrl: String
        get() = cachedApiUrl

    private val cachedWsUrl: String by lazy {
        cachedApiUrl
            .replace("http://", "ws://")
            .replace("https://", "wss://")
            .replace("/api", "/ws")
    }

    val wsUrl: String
        get() = cachedWsUrl

    val appName: String = "WebTemplate"
    val appVersion: String = "1.0.0"

    val googleClientId: String
        get() = getEnv("GOOGLE_CLIENT_ID") ?: "YOUR_GOOGLE_CLIENT_ID"

    val appleClientId: String
        get() = getEnv("APPLE_CLIENT_ID") ?: "YOUR_APPLE_SERVICES_ID"

    fun getApiUrl(path: String): String {
        val cleanPath = path.removePrefix("/")
        return "$apiUrl/$cleanPath"
    }

    private fun getEnv(key: String): String? {

        val metaTag = window.document.querySelector("meta[name=\"$key\"]")
        if (metaTag != null) {
            return metaTag.getAttribute("content")
        }

        val globalConfig = window.asDynamic().__APP_CONFIG__
        if (globalConfig != null) {
            val configValue = globalConfig[key]
            if (configValue != null && configValue != js("undefined")) {
                return configValue.toString()
            }
        }

        return null
    }
}

enum class Environment {
    DEVELOPMENT,
    PRODUCTION
}
